const state = {
    crmgroups:[],
};

const getters = {
    getCrmGroups: state => state.crmgroups,
};

const actions = {
    setCrmGroups: (store, payload) => store.commit('CRMGROUPS_SET', payload),
};

const mutations = {
    CRMGROUPS_SET: (state, payload) => state.crmgroups = payload,
};

export default {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
